import React from "react";
import { useTranslation } from "react-i18next";

interface FrequencySelectorProps {
  selectedFrequency?: string;
  onFrequencySelect?: (frequency: string) => void;
  isDisabled?: boolean;
  className?: string;
}

const FREQUENCY_OPTIONS: { value: string; labelKey: string }[] = [
  { value: "none", labelKey: "sessionForm.doesNotRepeat" },
  { value: "daily", labelKey: "sessionForm.daily" },
  { value: "weekday", labelKey: "sessionForm.everyWeekday" },
  { value: "weekly", labelKey: "sessionForm.weekly" },
  { value: "monthly", labelKey: "sessionForm.monthly" },
  { value: "custom", labelKey: "sessionForm.customFrequency" },
];

const FrequencySelector: React.FC<FrequencySelectorProps> = ({
  selectedFrequency,
  onFrequencySelect,
  isDisabled = false,
  className = "",
}) => {
  const { t } = useTranslation();

  const handleFrequencySelect = (frequency: string) => {
    if (onFrequencySelect) {
      onFrequencySelect(frequency);
    }
  };

  return (
    <div className={`space-y-2 ${className}`} data-testid="frequency-selector">
      <p className="font-bold">{t("sessionForm.sessionFrequency")}</p>

      <div
        className={`flex max-w-[476px] flex-wrap gap-4 ${
          isDisabled ? "opacity-50" : ""
        }`}
      >
        {FREQUENCY_OPTIONS.map((option) => (
          <label
            key={option.value}
            className={`flex ${
              isDisabled ? "cursor-not-allowed" : "cursor-pointer"
            }`}
          >
            <input
              type="radio"
              name="frequency"
              value={option.value}
              className="peer hidden"
              checked={selectedFrequency === option.value}
              onChange={() => handleFrequencySelect(option.value)}
              disabled={isDisabled}
            />
            <span className="checkbox-group-item py-0">{t(option.labelKey)}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default FrequencySelector;
